import FileUploadIcon from "@rsuite/icons/FileUpload";
import { useCallback, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import {
  Button,
  DatePicker,
  IconButton,
  Input,
  SelectPicker,
  Tag,
  Uploader,
} from "rsuite";
import { APi } from "../../Api";
import { OperationTypeAtom } from "../../Atoms/operationTypes.atom";
import { umrahPacksVols } from "../../Atoms/umrahPacks.atom";
import { userAtom } from "../../Atoms/user.atom";
import Label from "../../Components/Label";
import Responsive from "../../Components/Responsive";
import { BASE_URL } from "../../Config/api.config";
import { TypePaiment, serviceTypes } from "../../Constants/types";
import B2CInformationsPanel from "./B2CInfos/B2CInfo";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import PaidForPanel from "./PaidFor/paidFor";
import { PaidForModel } from "../../Models/transactionModel";
import { transactions } from "../../Atoms/transaction.atom";
import ReferrerModal from "../../Components/modal/Referrer";
import moment from "moment";
import format_number from "../../Helpers/number_formatter";
import Grid from "../../Components/Grid";
import ListTransactions from "../JournalCheckout/ListTransactions";

const AddEditTransaction = ({
  _setmodel,
  model,
  clients,
  credit,
  loadingAttach,
  checkouts = [],
  correct,
  loadingCorrection,
  isExpense,
}) => {
  const [files, setfiles] = useState([]);
  const [loading, setloading] = useState(false);
  const user = useRecoilValue(userAtom);
  const operationTypes = useRecoilValue(OperationTypeAtom);
  const vols = useRecoilValue(umrahPacksVols);
  const transaction = useRecoilValue(transactions);
  const [clientsB2C, setClientB2C] = useState([]);
  const [error, setError] = useState("");
  const [referrersData, setReferrersData] = useState([]);
  const [transactionParent, setTransactionParent] = useState(null);
  const [open, setOpen] = useState(false);
  const [transactionsData, setTransactionsData] = useState([]);
  const [show, setShow] = useState(false);

  const columns = [
    {
      value: "date",
      name: "Date",

      render: (v) => (
        <h6
          style={{
            fontSize: "12px",
          }}
        >
          {moment(v).format("DD MMM YYYY")}
        </h6>
      ),
    },

    {
      value: "infosB2C",
      name: "Client",
      render: (v) => (
        <b style={{ color: "#4c67c2" }}>{v ? v.fullName.toUpperCase() : "-"}</b>
      ),
    },

    {
      value: "amount",
      name: "Totale",
      render: (v) => (
        <b style={{ fontSize: "14px", color: "#549f0a" }}>
          {v ? format_number(v) : ""}
        </b>
      ),
    },
    {
      value: "amountToBePaid",
      name: "Reste à payé",
      render: (v) => (
        <b style={{ fontSize: "14px" }}>{format_number(v || 0)}</b>
      ),
    },

    {
      value: "paymentStatus",
      name: "Status",
      render: (v) => (
        <b style={{ fontSize: "14px", color: v === 1 && "#549f0a" }}>
          {v === 0 ? "Partiellement payé" : "Payé"}
        </b>
      ),
    },

    {
      value: "checkout",
      name: "Caisse",
      render: (v) => <b style={{ color: "#4c67c2" }}>{v ? v.name : "-"}</b>,
    },

    {
      value: "service",
      name: "Service",
      render: (v) =>
        v ? (
          <Tag
            color={
              v == 1
                ? "blue"
                : v == 2
                ? "green"
                : v == 3
                ? "red"
                : v == 4
                ? "black"
                : v == 5
                ? "orange"
                : v == 6
                ? "violet"
                : v == 7
                ? "yellow"
                : "teal"
            }
          >
            {serviceTypes.find((el) => el.value == v)
              ? serviceTypes.find((el) => el.value == v).label
              : "Autres"}
          </Tag>
        ) : (
          "-"
        ),
    },
  ];

  const fetchReferrers = useCallback(() => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Transaction + "/GetAllReferrer", {})
      .customGet()
      .then((res) => {
        setReferrersData(res.data);
      });
  }, []);

  useEffect(() => {
    fetchReferrers();
  }, [fetchReferrers]);

  const getReferrersData = () =>
    referrersData?.map((referrer) => {
      return {
        label: referrer.name,
        value: referrer.id,
      };
    });

  useEffect(() => {
    if (model.attachments) {
      setfiles(
        model.attachments
          .split(",")
          .filter((el) => el)
          .map((el) => ({ status: "finished", fileKey: el, name: el }))
      );
    }
  }, [model.id]);

  const handleClose = () => {
    setOpen(false);
  };

  const upload = (list, file, fileKey) => {
    setloading(true);
    APi.createAPIEndpoint(APi.ENDPOINTS.File + "/Upload")
      .upload2(file, "File")
      .then((res) => {
        setloading(false);
        let i = list.findIndex((el) => el.fileKey == fileKey);
        setfiles((prev) => {
          let items = [...list];
          items[i].status = "finished";
          items[i].name = res.data;
          return items;
        });
        let attachments =
          model.attachments && model.attachments != undefined
            ? model.attachments
            : "";
        attachments = attachments ? attachments + "," + res.data : res.data;
        _setmodel((prev) => {
          return { ...prev, attachments };
        });
        if (model.id) {
          APi.createAPIEndpoint(APi.ENDPOINTS.Transaction)
            .update(model.id, {
              ...model,
              attachments,
            })
            .then((res) => {
              // Swal.fire({
              //   position: "top-end",
              //   icon: "success",
              //   title: "Élément a été bien modifié !",
              //   showConfirmButton: false,
              //   timer: 1500,
              // });
            })
            .catch((e) => {});
        }
      })
      .catch((error) => {
        setloading(false);

        let i = list.findIndex((el) => el.fileKey == fileKey);
        setfiles((prev) => {
          let items = [...list];
          items[i].status = "error";
          return items;
        });
      });
  };

  const _delete = (fileKey) => {
    let i = files.findIndex((el) => el.fileKey == fileKey);
    APi.createAPIEndpoint(APi.ENDPOINTS.File)
      .delete(files[i].name)
      .then((res) => {
        setfiles((prev) => {
          let items = [...prev];
          return items.filter((el, j) => j != i);
        });

        let attachments = model.attachments.replace(files[i].name, "");
        attachments = attachments.replace(",,", ",");
        if (model.id) {
          APi.createAPIEndpoint(APi.ENDPOINTS.Transaction)
            .update(model.id, {
              ...model,
              attachments,
            })
            .then((res) => {
              // Swal.fire({
              //   position: "top-end",
              //   icon: "success",
              //   title: "Élément a été bien modifié !",
              //   showConfirmButton: false,
              //   timer: 1500,
              // });
            })
            .catch((e) => {});
        }
        _setmodel((prev) => {
          return { ...prev, attachments };
        });
      })
      .catch((error) => {});
  };

  useEffect(() => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Transaction + "/GetAllInfoB2C")
      .fetchAll()
      .then((res) => {
        setClientB2C(res.data);
      })
      .catch((error) => {
        console.error(error, "error");
      });
  }, []);

  const handleAddPaidFor = () => {
    _setmodel((prev) => ({
      ...prev,
      users: [...prev.users, new PaidForModel()],
    }));
  };

  const handleDelete = (index) => {
    _setmodel((prev) => {
      const updatedPaidFor = prev.users.filter((_, idx) => idx !== index);
      return { ...prev, users: updatedPaidFor };
    });
  };

  const findTransaction = (id) => {
    const t = transaction.find((f) => f.value === id);
    return t.montant || 0;
  };

  const handleAmountChange = (event) => {
    let value = event.trim();
    let amount = value === "" ? "" : parseFloat(value);

    if (model.refund && model.transactionRefund) {
      const transactionAmount = findTransaction(model.transactionRefund);

      if (amount !== "" && amount > transactionAmount) {
        setError(
          "Le montant à rembourser ne peut pas dépasser le montant de la transaction."
        );
        return;
      } else {
        setError("");
      }

      _setmodel((prev) => ({
        ...prev,
        credit: model.refund && credit ? amount : "",
        debit: model.refund && credit ? "" : amount,
      }));
    } else if (
      transactionParent &&
      amount !== "" &&
      amount > transactionParent.amountToBePaid
    ) {
      setError("Le montant ne peut pas dépasser le reste à payé.");
    } else if (
      !transactionParent &&
      (model.service == 6 || model.service == 7) &&
      model?.disponibilityId &&
      amount !== "" &&
      amount > model?.TotalPrice && model.isClientB2C
    ) {
      setError("Le montant ne peut pas dépasser le montant total.");
    } else {
      setError("");
      _setmodel((prev) => ({
        ...prev,
        credit: credit ? amount : "",
        debit: credit ? "" : amount,
      }));
    }
  };

  const handleReferrerSelect = (id) => {
    const selectedReferrer = referrersData?.find(
      (referrer) => referrer.id === id
    );
    if (selectedReferrer) {
      _setmodel((prev) => ({
        ...prev,
        referrerId: selectedReferrer.id,
      }));
    }
  };

  useEffect(() => {
    setError("");
    if (
      (model.service === 7 || model.service === 6) &&
      model?.infosB2C?.id &&
      model?.disponibilityId
    )
      APi.createAPIEndpoint(
        APi.ENDPOINTS.Transaction + "/GetTransactionParentById",
        {
          idClient: model?.infosB2C?.id,
          idDisponibility: model?.disponibilityId,
        }
      )
        .customGet()
        .then((res) => {
          setTransactionParent(res.data);
        })
        .catch((error) => {
          console.error(error, "error");
          setTransactionParent(null);
        });
  }, [model?.infosB2C?.id, model?.disponibilityId, model?.service]);

  const displayAction = (id) => {
    APi.createAPIEndpoint(
      APi.ENDPOINTS.Transaction +
        `/GetTransactionParentByIdWithTransactions/${id}`
    )
      .fetchAll()
      .then((res) => {
        setTransactionsData(res.data.transactions);
      })
      .catch((e) => {
        console.error(e);
        setTransactionsData([]);
      });
  };

  return (
    <div>
      {credit ? (
        <div style={{ display: "flex", gap: "20px" }}>
          <Label>
            <input
              type="checkbox"
              // value={model.authorizationStatus}
              checked={true}
              // onChange={(e) =>
              //   _setmodel((prev) => ({
              //     ...prev,
              //     authorizationStatus: e.target.checked
              //       ? 2
              //       : prev.authorizationStatus,
              //   }))
              // }
            />
            <b> Demande d'autorisation</b>
          </Label>

          <Label>
            <input
              type="checkbox"
              checked={model.refund}
              onChange={(e) => {
                _setmodel((prev) => ({
                  ...prev,
                  refund: e.target.checked,
                  debit: 0,
                  credit: 0,
                  transactionRefund: null,
                }));
                setError("");
              }}
            />
            <b> Remboursement</b>
          </Label>
        </div>
      ) : (
        ""
      )}

      {!credit && !isExpense && (
        <div style={{ display: "flex", gap: "20px" }}>
          <Label>
            <input
              type="checkbox"
              checked={!model.isClientB2C}
              onChange={() =>
                _setmodel((prev) => ({
                  ...prev,
                  isClientB2C: false,
                }))
              }
            />
            <b> Client B2B</b>
          </Label>
          <Label>
            <input
              type="checkbox"
              checked={model.isClientB2C}
              onChange={() =>
                _setmodel((prev) => ({
                  ...prev,
                  isClientB2C: true,
                }))
              }
            />
            <b> Client B2C</b>
          </Label>
        </div>
      )}

      {model.id &&
      !model.correctionTransactionId &&
      !model.errorTransactionId &&
      user.checkoutId ? (
        <div style={{ textAlign: "right" }}>
          <Button
            loading={loadingCorrection}
            onClick={() => correct(model)}
            color="red"
            appearance="primary"
          >
            Corriger
          </Button>
        </div>
      ) : (
        ""
      )}
      {!user.checkoutId && (
        <Responsive m={6} l={6} xl={6} className="p-10">
          <Label required>Caisse : </Label>
          <SelectPicker
            data={[{ label: "Tout", value: 0 }].concat(
              checkouts.map((el) => {
                return { value: el.id, label: el.name };
              })
            )}
            block
            noSearch
            value={model.checkoutId}
            onSelect={(checkoutId) => {
              _setmodel((prev) => {
                return { ...prev, checkoutId };
              });
            }}
          />
        </Responsive>
      )}
      <Responsive m={6} l={6} xl={6} className="p-10">
        <Label required>Service : </Label>
        <SelectPicker
          data={serviceTypes}
          block
          noSearch
          value={model.service}
          onSelect={(service) => {
            _setmodel((prev) => {
              return { ...prev, service };
            });
          }}
        />
      </Responsive>

      <Responsive m={6} l={6} xl={6} className="p-10">
        <Label required>Type d'operation:</Label>
        <SelectPicker
          data={operationTypes
            .filter(
              (el) => (el.isExpense && credit) || (!el.isExpense && !credit)
            )
            .map((c) => {
              return { label: c.designation, value: c.id };
            })}
          block
          noSearch
          value={model.operationTypeId}
          onSelect={(operationTypeId) => {
            _setmodel((prev) => {
              return { ...prev, operationTypeId };
            });
          }}
        />
      </Responsive>

      {(model.service == 6 || model.service == 7) && (
        <Responsive m={12} l={12} xl={12} className="p-10">
          <Label required={model.service === 7 && !credit}>Vol : </Label>
          <SelectPicker
            data={vols}
            block
            value={model.disponibilityId}
            onSelect={(disponibilityId) => {
              _setmodel((prev) => {
                return {
                  ...prev,
                  disponibilityId,
                  TotalPrice: 0,
                  credit: 0,
                  debit: 0,
                };
              });
            }}
          />
        </Responsive>
      )}

      {!credit && model.isClientB2C && (
        <Responsive className="p-10">
          <B2CInformationsPanel
            model={model}
            setModel={_setmodel}
            data={clientsB2C}
            title={"Informations client"}
          />
          <br></br>
          {(model.service == 6 || model.service == 7) &&
            model?.disponibilityId &&
            model?.infosB2C?.id &&
            transactionParent && (
              <Grid
                actionKey="id"
                columns={columns}
                noAdvancedActions
                rows={[transactionParent]}
                displayAction={(id) => {
                  displayAction(id);
                  setShow(true);
                }}
              />
            )}

          {(model.service == 6 || model.service == 7) &&
            model?.disponibilityId &&
            !transactionParent && (
              <div>
                <Responsive
                  m={12}
                  l={12}
                  xl={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  className="p-5"
                >
                  <p style={{ color: "#FF0000", fontSize: "18px" }}>
                    Il n'y a pas de transaction liée à ce client, ajouter le
                    montant total du vol.
                  </p>
                </Responsive>
                <Responsive m={12} l={12} xl={12} className="p-5">
                  <label required>Montant Total:</label>
                  <Input
                    type="number"
                    step="0.1"
                    value={model?.TotalPrice || ""}
                    onChange={(value) =>
                      _setmodel((prev) => ({
                        ...prev,
                        TotalPrice: parseFloat(value),
                      }))
                    }
                  />
                </Responsive>
              </div>
            )}
        </Responsive>
      )}

      {credit && model.operationTypeId === 4 && (
        <Responsive m={6} l={6} xl={6} className="p-10">
          <Label required>Nom de rabatteur</Label>
          <IconButton
            onClick={() => setOpen(true)}
            icon={<PlusRoundIcon />}
            style={{
              background: "transparent",
              border: "none",
              boxShadow: "none",
            }}
          />

          <SelectPicker
            data={getReferrersData()}
            block
            value={model.referrerId}
            onSelect={handleReferrerSelect}
          />
        </Responsive>
      )}

      <Responsive m={6} l={6} xl={6} className="p-10">
        <Label required>Type de paiment:</Label>
        <SelectPicker
          data={
            !credit
              ? TypePaiment
              : TypePaiment.filter((item) => item.value !== 1)
          }
          block
          noSearch
          value={model.paiment}
          onSelect={(paiment) => {
            _setmodel((prev) => {
              return { ...prev, paiment };
            });
          }}
        />
      </Responsive>

      {model.paiment === 1 && (
        <>
          <Responsive m={6} l={6} xl={6} className="p-10">
            <Label>Référence chèque :</Label>
            <Input
              value={model.refCheck}
              onChange={(refCheck) => {
                _setmodel((prev) => {
                  return { ...prev, refCheck };
                });
              }}
            />
          </Responsive>
          <Responsive m={6} l={6} xl={6} className="p-10">
            <Label>date d'échéance :</Label>
            <DatePicker
              format="dd/MM/yyyy"
              style={{ display: "block" }}
              value={new Date(model.dueDate)}
              onChange={(dueDate) => {
                _setmodel((prev) => {
                  return { ...prev, dueDate };
                });
              }}
            />
          </Responsive>
        </>
      )}
      {credit && (
        <Responsive m={6} l={6} xl={6} className="p-10">
          <Label>Bénéficiaire</Label>
          {!credit && !model.isUmrahB2C && <Label>Clients B2B</Label>}
          <SelectPicker
            data={[{ label: "Tout", value: null }].concat(
              clients.map((c) => {
                return { label: c.name, value: c.id };
              })
            )}
            block
            noSearch
            value={model.clientId}
            onSelect={(clientId) => {
              _setmodel((prev) => {
                return { ...prev, clientId };
              });
            }}
          />
        </Responsive>
      )}

      {!credit && !model.isClientB2C && (
        <Responsive m={6} l={6} xl={6} className="p-10">
          <Label required>Clients B2B</Label>
          <SelectPicker
            data={clients.map((c) => {
              return { label: c.name, value: c.id };
            })}
            block
            noSearch
            value={model.clientId}
            onSelect={(clientId) => {
              _setmodel((prev) => {
                return { ...prev, clientId };
              });
            }}
          />
        </Responsive>
      )}

      {model.refund && (
        <Responsive m={6} l={6} xl={6} className="p-10">
          <Label required>Transaction à rembourser : </Label>
          <SelectPicker
            data={transaction}
            block
            value={model.transactionRefund}
            onSelect={(transactionRefund) => {
              _setmodel((prev) => {
                return { ...prev, transactionRefund, debit: 0, credit: 0 };
              });
              setError("");
            }}
          />
        </Responsive>
      )}

      {model.transactionRefund && model.refund && (
        <Responsive m={6} l={6} xl={6} className="p-10">
          <Label>Montant :</Label>
          <Input
            type="text"
            value={findTransaction(model.transactionRefund)}
            disabled
          />
        </Responsive>
      )}

      <Responsive m={6} l={6} xl={6} className="p-10">
        <Label required>Montant {model.refund && "à rembourser"} :</Label>
        <Input
          type="number"
          step="0.1"
          value={model.credit || model.debit || ""}
          onChange={handleAmountChange}
        />
        {error && (
          <div
            style={{ color: "red", fontSize: "0.875rem", marginTop: "0.5rem" }}
          >
            {error}
          </div>
        )}
      </Responsive>

      <Responsive m={6} l={6} xl={6} className="p-10">
        <Label>Représentant:</Label>
        <Input
          value={model.representative}
          onChange={(representative) => {
            _setmodel((prev) => {
              return { ...prev, representative };
            });
          }}
        />
      </Responsive>

      <Responsive className="p-10">
        <Label required={!model.disponibilityId}>Designation:</Label>
        <Input
          as="textarea"
          rows={3}
          value={model.designation}
          onChange={(designation) => {
            _setmodel((prev) => {
              return { ...prev, designation };
            });
          }}
        />
      </Responsive>

      {!credit && model.isClientB2C && (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "5px",
            }}
          >
            <h6>Conjoint :</h6>
            <IconButton onClick={handleAddPaidFor} icon={<PlusRoundIcon />} />
          </div>

          {model?.users?.map((info, index) => (
            <>
              <PaidForPanel
                index={index}
                info={info}
                setModel={_setmodel}
                data={clientsB2C}
                title={`Conjoint ${index + 1}`}
                onDelete={handleDelete}
              />
              <br></br>
            </>
          ))}
        </div>
      )}
      <br></br>

      <Responsive className="p-10">
        {" "}
        <Label>Attachements:</Label>
        <Uploader
          renderFileInfo={(file, fileElement) => {
            return (
              <div>
                <a
                  target="_blank"
                  download
                  href={BASE_URL + "Uploads/" + file.name}
                  rel="noreferrer"
                >
                  {file.name}
                </a>
              </div>
            );
          }}
          loading={loadingAttach}
          autoUpload={false}
          fileList={files}
          action="#"
          draggable
          onRemove={(f) => _delete(f.fileKey)}
          onChange={(list) => {
            let file = list
              .filter((el) => el.status != "finished")
              .reverse()[0];
            if (file) upload(list, file.blobFile, file.fileKey);
          }}
        >
          <div style={{ background: "rgba(200,200,200,0.1)" }}>
            <div style={{ fontSize: "50px" }}>
              {" "}
              <FileUploadIcon color="#3598ff"></FileUploadIcon>
            </div>
            <h4 style={{ color: "#bbb", fontWeight: "400" }}>
              Clicker ou Faites glisser les fichiers vers cette zone
            </h4>
          </div>
        </Uploader>
      </Responsive>
      {open && (
        <ReferrerModal
          open={open}
          handleClose={handleClose}
          fetchReferrers={fetchReferrers}
        />
      )}
      <ListTransactions
        show={show}
        close={() => setShow(false)}
        data={transactionsData}
      />
    </div>
  );
};

export default AddEditTransaction;
